import ResourceEmptyList from '@components/ResourceList/ResourceEmptyList/ResourceEmptyList'
import ResourceList from '@components/ResourceList/ResourceList'
import { useDashboardListData } from '@hooks/useDashboardListData'
import { useListParams } from '@hooks/useListParams'
import type { ResourceScope } from 'src/types/global'

interface DashboardListProps {
  scope: ResourceScope
}

export default function DashboardList({ scope }: DashboardListProps) {
  const items = useDashboardListData(scope)
  const finalItems = useListParams(items)

  if (!items.length) {
    return <ResourceEmptyList variant="empty" type="dashboard" />
  }
  if (!finalItems.length) {
    return <ResourceEmptyList variant="no-results" type="dashboard" />
  }
  return <ResourceList type="dashboard" items={finalItems} />
}
